export const cars =[
    {
        image: "/images/Renault_Sandero/1.webp",
        // title: "Renault Sandero"
    },
    {
        image: "/images/Renault_Sandero/1.webp",
        // title: "Renault Sandero"
    },
    {
        image: "/images/Renault_Sandero/1.webp",
        // title: "Renault Sandero"
    },
    {
        image: "/images/Renault_Sandero/4.avif",
        // title: "Renault Sandero"
    },
    {
        image: "/images/Renault_Sandero/5.avif",
        // title: "Renault Sandero"
    }
];